import {
  LabelLarge,
  LabelMedium,
  ModalBody,
  ModalFooter,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import MatsReward from "#/shared/components/MatsReward"
import { useModalCustomOptions, useStake } from "#/shared/hooks"
import { bigIntToHumanReadableFormat, networkUtils } from "#/shared/utils"
import { ComponentStepProps, SignTransactionModalButton } from "#/ui/Modal"

import { ReviewDetails, ReviewDetailsListItem } from "../components"

export default function ReviewAndSignStep({
  onClickContinue,
}: ComponentStepProps) {
  const [css, theme] = useStyletron()

  const { stakeId } = useModalCustomOptions<{
    stakeId: string
  }>()

  const selectedStake = useStake(stakeId)

  if (!selectedStake) return null

  const txDetails: ReviewDetailsListItem[] = [
    {
      label: "Amount",
      endEnhancer: (
        <>
          <LabelMedium>
            {bigIntToHumanReadableFormat(selectedStake.amount)} BTC
          </LabelMedium>
          {/* TODO: Set the correct USD value */}
          <ParagraphSmall color={theme.colors.contentSecondary}>
            $ 24,000
          </ParagraphSmall>
        </>
      ),
    },
  ]

  const rewardsDetails: ReviewDetailsListItem[] = [
    {
      label: "Mats rewards",
      endEnhancer: (
        <MatsReward
          label={<LabelLarge marginRight={theme.sizing.scale100}>-</LabelLarge>}
          iconSize={16}
        />
      ),
    },
  ]

  return (
    <>
      <ModalBody
        className={css({
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale600,
        })}
      >
        <ReviewDetails label="Withdraw" items={txDetails} />
        <ReviewDetails
          label="Unclaimed rewards"
          items={rewardsDetails}
          backgroundColor={theme.colors.lime300}
        />
      </ModalBody>
      <ModalFooter style={{ display: "block" }}>
        <SignTransactionModalButton
          onClick={onClickContinue}
          gasFee="$1.2"
          buttonLabel={`Sign on ${networkUtils.getMezoDAppLabel()}`}
        />
      </ModalFooter>
    </>
  )
}
